/*
  Shreya — <collection-tabs>
  One pair of heading arrows drives whichever tab panel is visible.
  Each panel owns its own <slider-carousel>; this element just forwards clicks
  and keeps the arrow disabled-state in sync with the active track.
*/
(() => {
  if (customElements.get('collection-tabs')) return;

  class CollectionTabs extends HTMLElement {
    connectedCallback() {
      this.prevBtn = this.querySelector('.collection-tabs__header [data-slider-prev]');
      this.nextBtn = this.querySelector('.collection-tabs__header [data-slider-next]');
      this.tabs = this.querySelector('tabs-component');

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.move(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.move(1));

      this.syncSoon = () => window.requestAnimationFrame(() => this.syncArrows());
      this.addEventListener('tabs:change', this.syncSoon);
      this.querySelectorAll('[data-slider-track]').forEach((track) => {
        track.addEventListener('scroll', this.syncSoon, { passive: true });
      });
      this.resizeWatch = new ResizeObserver(this.syncSoon);
      this.resizeWatch.observe(this);

      this.enableVerticalKeys();
      this.onBlockSelect = (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) tab.click();
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.syncSoon();
    }

    disconnectedCallback() {
      if (this.resizeWatch) this.resizeWatch.disconnect();
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    get activeCarousel() {
      const panel = this.querySelector('[role="tabpanel"]:not([hidden])');
      return panel ? panel.querySelector('slider-carousel') : null;
    }

    move(direction) {
      const carousel = this.activeCarousel;
      if (carousel && typeof carousel.go === 'function') carousel.go(direction);
    }

    syncArrows() {
      if (!this.prevBtn || !this.nextBtn) return;
      const carousel = this.activeCarousel;
      const track = carousel && carousel.querySelector('[data-slider-track]');
      if (!track) return;
      const room = track.scrollWidth - track.clientWidth;
      this.prevBtn.disabled = track.scrollLeft <= 4;
      this.nextBtn.disabled = room <= 4 || track.scrollLeft >= room - 4;
    }

    /* Vertical tab lists also answer to the up / down arrow keys. */
    enableVerticalKeys() {
      const list = this.querySelector('[role="tablist"][aria-orientation="vertical"]');
      if (!list || !this.tabs) return;
      const buttons = Array.from(list.querySelectorAll('[role="tab"]'));
      list.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        const current = buttons.indexOf(document.activeElement);
        if (current < 0) return;
        event.preventDefault();
        const step = event.key === 'ArrowDown' ? 1 : -1;
        const next = (current + step + buttons.length) % buttons.length;
        if (typeof this.tabs.select === 'function') this.tabs.select(next, true);
      });
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
})();
